import { GemsApi_StoneFluorescence } from '@/graphql/api'
import { computed, type ComputedRef, type Ref, toValue } from 'vue'
import { findOrder } from '@/domain/stone/search/findOrder'

const ordered: GemsApi_StoneFluorescence[] = [
    GemsApi_StoneFluorescence.None,
    GemsApi_StoneFluorescence.Faint,
    GemsApi_StoneFluorescence.VerySlight,
    GemsApi_StoneFluorescence.Slight,
    GemsApi_StoneFluorescence.Medium,
    GemsApi_StoneFluorescence.Strong,
    GemsApi_StoneFluorescence.VeryStrong,
] as const

function findFluorescenceOrder(code: GemsApi_StoneFluorescence) {
    return findOrder(ordered, code)
}

export function useOrderedFluorescence(
    shapes:
        | Ref<GemsApi_StoneFluorescence[]>
        | (() => GemsApi_StoneFluorescence[])
): ComputedRef<GemsApi_StoneFluorescence[]> {
    return computed(() => {
        return toValue(shapes).sort(
            (a: GemsApi_StoneFluorescence, b: GemsApi_StoneFluorescence) => {
                const orderA = findFluorescenceOrder(a)
                const orderB = findFluorescenceOrder(b)

                return orderA - orderB
            }
        )
    })
}
